var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgFbIcon = function SvgFbIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M15.188.188H.812a.624.624 0 0 0-.625.625v14.374c0 .346.28.626.625.626h14.376c.345 0 .624-.28.624-.626V.813a.624.624 0 0 0-.624-.625Zm-1.805 4.56h-1.248c-.979 0-1.168.465-1.168 1.148v1.506h2.336l-.305 2.358h-2.031v6.053H8.53V9.761H6.494v-2.36h2.037V5.664c0-2.018 1.233-3.117 3.034-3.117.863 0 1.603.064 1.82.094v2.107h-.002Z"
  })));
};
export default SvgFbIcon;